<template>
  <section class="p-0 m-0">
    <div class="row justify-content-center bg-white">
      <div class="col-xs-12 col-sm-12 col-md-10 col-lg-7 center">
        <h3 class="willkommen__title">{{ $t("So finden Sie uns") }}</h3>
        <p class="willkommen__text">
          {{
            $t(
              "Wir freuen uns, Sie in unserem traditionsreichen Hotel begrüßen zu dürfen!"
            )
          }}
        </p>
        <div class="row textcenter">
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-4 nodekoration">
            <a
              href="https://www.google.com/maps/dir/?api=1&destination=Schwarzburger+Straße+19,+07422+Bad+Blankenburg"
              target="_blank"
              rel="noopener"
              class="nodecoration"
            >
              <div class="card adressCard d-flex justify-content-center">
                <div class="card-body">
                  <div class="d-flex justify-content-center">
                    <img :src="require('@/assets/ort_icon.png')" class="icon-top" />
                  </div>

                  <h4 class="card-title adressCardHeader">
                    {{ $t("adresseName") }}
                  </h4>
                  <p class="card-text">
                    {{ $t("Familie Minner") }}<br />
                    {{ $t("adresseStrasse") }}, {{ $t("adresseOrt") }}
                  </p>
                </div>
              </div>
            </a>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-4">
            <div class="card adressCard d-flex justify-content-center">
              <div class="card-body">
                <div class="d-flex justify-content-center">
                  <img :src="require('@/assets/telefon_icon.png')" class="icon-top" />
                </div>
                <h4 class="card-title adressCardHeader">{{ $t("adresseTel") }}</h4>
                <p class="card-text">
                  {{ $t("Wir freuen uns, Ihnen Ihre Fragen zu beantworten") }}
                </p>
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-4">
            <a
              :href="'mailto:info@weinhaus-Eberitzsch.de'"
              class="nodecoration"
              style="width: 70px; height: 70px; padding-top: 10px"
            >
              <div class="card adressCard d-flex justify-content-center">
                <div class="card-body">
                  <div class="d-flex justify-content-center">
                    <img :src="require('@/assets/mail_icon.png')" class="icon-top" />
                  </div>
                  <h4 class="card-title adressCardHeader">
                    {{ $t("adresseMail") }}@{{ $t("adresseMailDomain") }}
                  </h4>
                  <p class="card-text">
                    {{
                      $t(
                        "Alternativ können Sie uns selbstverständlich gern eine E-Mail senden. Ihre Fragen beantworten wir gern."
                      )
                    }}
                  </p>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
  <footer>
    <Container fluid>
      <Div class="row justify-content-center">
        <Div class="col-md-11">
          <hr />
        </Div>
      </Div>

      <Div class="row justify-content-center">
        <Div class="col-md-3">
          <h4 class="fw-bolder">
            <router-link to="/impressum" class="footerLink">{{
              $t("impressum")
            }}</router-link>
          </h4>
        </Div>
        <Div class="col-md-6">
          {{ $t("adresseName") }}, {{ $t("adresseStrasse") }}, {{ $t("adresseOrt")
          }}<br />
          <i class="bi bi-telephone ps-4 pe-2"> </i>{{ $t("adresseTel") }},
          <i class="bi bi-printer ps-4 pe-2"> </i>{{ $t("adresseFax") }},
          <i class="bi bi-info-square ps-4 pe-2 footerLink"> </i
          ><a
            :href="'mailto:info@weinhaus-Eberitzsch.de'"
            class="footerLink"
            style="width: 70px; height: 70px; padding-top: 10px"
          >
            <span style="height: 70px; padding-top: 10px; margin-top: -10px">
              {{ $t("adresseMail") }}@{{ $t("adresseMailDomain") }}</span
            ></a
          >
        </Div>
        <Div class="col-md-3">
          <h4 class="fw-bolder">
            <router-link to="/datenschutz" class="footerLink">{{
              $t("datenschutz")
            }}</router-link>
          </h4>
        </Div>
      </Div>
      <Div class="row justify-content-center">
        <Div class="col-md-3">
          <p>&copy; {{ new Date().getFullYear() }} {{ $t("adresseName") }}</p>
          <P class="fw-bold"
            ><a href="https://Pillarsoft.de" class="footerLink" target="_blank">
              <span style="height: 70px; padding-top: 10px; margin-top: -10px">
                {{ $t("Webdesign by Pillarsoft.de") }}</span
              ></a
            ></P
          >
        </Div>
      </Div>
      <Div
        class="row justify-content-center bildschirmansicht"
        v-if="HomepageCookiePillarSoft != $t('adresseName')"
      >
        <Div class="col-md-6">
          {{
            $t(
              "Wir setzen auf unserer Website kein herkömmliches Cookie-basiertes Tracking"
            )
          }}
        </Div>
        <Div class="col-md-3">
          <button
            type="button"
            class="btn btn-outline-danger mx-3"
            @click="openCookieDetail()"
          >
            {{ $t("Details") }}
          </button>
          <button type="button" class="btn btn-danger" @click="setCookie()">
            {{ $t("Hinweis schließen") }}
          </button>
        </Div>
      </Div>
    </Container>
  </footer>
</template>

<script>
import ModalCookieDetail from "../components/ModalCookieDetail.vue";
import { openModal } from "jenesius-vue-modal";
import "bootstrap-icons/font/bootstrap-icons.css";
//import { computed } from 'vue';

//const currentYear = computed(() => new Date().getFullYear());

export default {
  name: "AppFooter",
  data() {
    return {
      HomepageCookiePillarSoft: "",
    };
  },
  methods: {
    openCookieDetail() {
      openModal(ModalCookieDetail);
    },
    setCookie() {
      // Cookie setzen
      this.$cookies.set("HomepageCookiePillarSoft", this.$t("adresseName"));
      this.HomepageCookiePillarSoft = this.$t("adresseName");
    },
  },
  mounted() {
    // Cookie auslesen
    this.HomepageCookiePillarSoft = this.$cookies.get("HomepageCookiePillarSoft");
    console.log("HomepageCookiePillarSoft:", this.HomepageCookiePillarSoft);
  },
};
</script>
